import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, theme, useResponsive } from '@sg/garnish';

import { useTrademark } from '@order/hooks';
import { useLocalizationContext } from '@order/Localization';

import { DebugMenuTrigger } from '../../DebugMenu';

export const OrganizationLinksFooterCopyright = () => {
  const { t } = useLocalizationContext();
  const trademark = useTrademark();

  const { minWidth } = useResponsive();
  const alignmentStyle = minWidth.isMD ? styles.alignmentMD : undefined;

  return (
    <View>
      <BodyText style={alignmentStyle}>
        {t('footer.copyright', { year: CURRENT_YEAR })}
      </BodyText>

      {trademark ? (
        <BodyText style={[styles.trademark, alignmentStyle]}>
          {trademark}
        </BodyText>
      ) : null}

      <BodyText style={alignmentStyle}>
        <DebugMenuTrigger />
      </BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CURRENT_YEAR = new Date().getFullYear();

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  alignmentMD: {
    textAlign: 'right',
  },
  trademark: {
    marginBottom: theme.spacing['4'],
  },
});
